(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    

  (() => {

    const openButtons =
      document.querySelectorAll(
        '[data-sewsans-menu-open]'
      );

    openButtons.forEach((openButton) => {

      const controlsId =
        openButton.getAttribute(
          'aria-controls'
        );

      if (!controlsId) return;

      const drawer =
        document.getElementById(
          controlsId
        );

      if (!drawer) return;

      const closeButtons =
        drawer.querySelectorAll(
          '[data-sewsans-menu-close]'
        );


      const openDrawer =
        () => {

          drawer.hidden = false;

          openButton.setAttribute(
            'aria-expanded',
            'true'
          );

          document.documentElement.style.overflow =
            'hidden';

          const closeButton =
            drawer.querySelector(
              '.sewsans-mobile-menu__close'
            );

          if (closeButton) {
            closeButton.focus();
          }

        };


      const closeDrawer =
        () => {

          drawer.hidden = true;

          openButton.setAttribute(
            'aria-expanded',
            'false'
          );

          document.documentElement.style.overflow =
            '';

          openButton.focus();

        };


      openButton.addEventListener(
        'click',
        openDrawer
      );


      closeButtons.forEach(
        (button) => {

          button.addEventListener(
            'click',
            closeDrawer
          );

        }
      );


      drawer.addEventListener(
        'keydown',
        (event) => {

          if (event.key === 'Escape') {
            closeDrawer();
          }

        }
      );

    });

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewsans-etsy-testimonials"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.sewsansProductReviewsInitialized) return;
  window.sewsansProductReviewsInitialized = true;
  const clear = (host) => {
    if (!host) return;
    host.hidden = true;
    host.replaceChildren();
  };
  const mountReviews = () => {
    const sources = Array.from(document.querySelectorAll('[data-product-review-source="true"]'));
    sources.forEach((source) => { source.hidden = false; });
    document.querySelectorAll('.sewsans-product').forEach((productSection) => {
      const summary = productSection.querySelector('[data-product-review-summary]');
      const featured = productSection.querySelector('[data-product-featured-review]');
      const full = productSection.querySelector('[data-product-full-reviews]');
      const cardsHost = productSection.querySelector('[data-product-review-cards]');
      clear(summary);
      clear(featured);
      if (full) full.hidden = true;
      if (cardsHost) cardsHost.replaceChildren();
      if (!summary || !featured || !full || !cardsHost) return;
      const matchingSources = sources.filter((source) => source.dataset.productHandle === productSection.dataset.productHandle);
      const cards = matchingSources.flatMap((source) => Array.from(source.querySelectorAll('.ss-testimonial')));
      if (!cards.length) return;
      const ratings = cards.map((card) => Number(card.dataset.reviewRating)).filter((rating) => Number.isFinite(rating) && rating >= 1 && rating <= 5);
      const link = document.createElement('a');
      link.className = 'sewsans-review-summary__rating';
      link.href = `#${full.id}`;
      const countLabel = cards.length === 1 ? '1 selected review' : `${cards.length} selected reviews`;
      if (ratings.length === cards.length) {
        const average = ratings.reduce((sum, rating) => sum + rating, 0) / ratings.length;
        const stars = document.createElement('span');
        stars.className = 'sewsans-review-summary__stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.textContent = '★★★★★';
        stars.setAttribute('style', `--review-stars-fill: ${average / 5 * 100}%`);
        const fill = document.createElement('span');
        fill.className = 'sewsans-review-summary__stars-fill';
        fill.textContent = '★★★★★';
        stars.append(fill);
        const score = document.createElement('span');
        score.className = 'sewsans-review-summary__score';
        score.textContent = `${average.toFixed(1)} / 5`;
        link.append(stars, score);
        link.setAttribute('aria-label', `${average.toFixed(1)} out of 5 stars from ${countLabel} originally posted on Etsy. Read product reviews.`);
      }
      const count = document.createElement('span');
      count.className = 'sewsans-review-summary__count';
      count.textContent = countLabel;
      link.append(count);
      const sourceLine = document.createElement('p');
      sourceLine.className = 'sewsans-review-summary__source';
      const etsyLabel = document.createElement('span');
      etsyLabel.className = 'sewsans-review-summary__etsy';
      etsyLabel.textContent = 'Etsy';
      sourceLine.append(etsyLabel, document.createTextNode('Customer reviews'));
      const shopUrl = matchingSources.map((source) => source.dataset.etsyReviewsUrl).find(Boolean);
      const originalLink = cards.map((card) => card.querySelector('.ss-testimonial__source a')).find(Boolean);
      const sourceUrl = shopUrl || (originalLink ? originalLink.getAttribute('href') : '');
      if (sourceUrl) {
        const externalLink = document.createElement('a');
        externalLink.className = 'sewsans-review-summary__source-link';
        externalLink.href = sourceUrl;
        externalLink.target = '_blank';
        externalLink.rel = 'noopener noreferrer';
        externalLink.textContent = shopUrl ? 'View reviews on Etsy ↗' : 'View original review ↗';
        sourceLine.append(externalLink);
      }
      summary.append(link, sourceLine);
      summary.hidden = false;
      const hasPhoto = (card) => Boolean(card.querySelector('.ss-testimonial__image'));
      const chosen = cards.find((card) => card.dataset.reviewFeatured === 'true' && hasPhoto(card))
        || cards.find(hasPhoto)
        || cards.find((card) => card.dataset.reviewFeatured === 'true')
        || cards[0];
      const quote = chosen.querySelector('.ss-testimonial__quote p');
      if (quote && quote.textContent.trim()) {
        const words = quote.textContent.trim().split(/\s+/);
        const excerpt = document.createElement('blockquote');
        excerpt.textContent = words.slice(0, 32).join(' ') + (words.length > 32 ? '…' : '');
        const body = document.createElement('div');
        body.className = 'sewsans-featured-review__body';
        const header = document.createElement('div');
        header.className = 'sewsans-featured-review__header';
        const rating = Number(chosen.dataset.reviewRating);
        if (Number.isInteger(rating) && rating >= 1 && rating <= 5) {
          const stars = document.createElement('span');
          stars.className = 'sewsans-featured-review__stars';
          stars.setAttribute('role', 'img');
          stars.setAttribute('aria-label', `${rating} out of 5 stars`);
          const icons = document.createElement('span');
          icons.setAttribute('aria-hidden', 'true');
          icons.textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
          stars.append(icons);
          header.append(stars);
        }
        const sourceLabel = document.createElement('span');
        sourceLabel.className = 'sewsans-featured-review__source';
        sourceLabel.textContent = 'Customer review · Etsy';
        header.append(sourceLabel);
        const attribution = document.createElement('div');
        attribution.className = 'sewsans-featured-review__attribution';
        const name = chosen.querySelector('cite');
        if (name && name.textContent.trim()) {
          const cite = document.createElement('cite');
          cite.textContent = name.textContent.trim();
          attribution.append(cite);
        } else { attribution.textContent = 'Etsy customer'; }
        const date = chosen.querySelector('time');
        if (date && date.textContent.trim()) attribution.append(date.cloneNode(true));
        const links = document.createElement('div');
        links.className = 'sewsans-featured-review__links';
        const source = chosen.querySelector('.ss-testimonial__source a');
        if (source && source.getAttribute('href')) {
          const original = document.createElement('a');
          original.href = source.getAttribute('href');
          original.target = '_blank';
          original.rel = 'noopener noreferrer';
          original.textContent = 'View original Etsy review ↗';
          links.append(original);
        }
        const readLink = document.createElement('a');
        readLink.href = `#${full.id}`;
        readLink.textContent = 'Read product reviews';
        links.append(readLink);
        body.append(header, attribution, excerpt, links);
        const photo = chosen.querySelector('.ss-testimonial__image');
        if (photo) {
          const image = photo.cloneNode(true);
          image.className = 'sewsans-featured-review__photo';
          image.setAttribute('sizes', '(max-width: 420px) 72px, 96px');
          if (!image.getAttribute('alt')) image.setAttribute('alt', 'Photo attached to this testimonial');
          const photoFrame = document.createElement('div');
          photoFrame.className = 'sewsans-featured-review__photo-frame';
          photoFrame.append(image);
          featured.append(photoFrame);
        }
        featured.append(body);
        featured.hidden = false;
      }
      const track = document.createElement('div');
      track.className = 'ss-testimonials__track';
      track.setAttribute('role', 'list');
      track.setAttribute('aria-label', 'Selected Etsy reviews for this product');
      cards.forEach((card) => {
        const copy = card.cloneNode(true);
        [copy, ...copy.querySelectorAll('*')].forEach((element) => {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
        });
        track.append(copy);
      });
      cardsHost.append(track);
      full.hidden = false;
      if (!window.Shopify || !window.Shopify.designMode) matchingSources.forEach((source) => { source.hidden = true; });
      [summary, featured].forEach((host) => {
        host.querySelectorAll('a').forEach((anchor) => {
          if (anchor.getAttribute('href') !== `#${full.id}`) return;
          anchor.addEventListener('click', () => {
            const heading = full.querySelector('h2');
            if (heading) heading.focus({ preventScroll: true });
          });
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountReviews, { once: true });
  else mountReviews();
  document.addEventListener('shopify:section:load', mountReviews);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(mountReviews));
  document.addEventListener('shopify:section:reorder', mountReviews);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sewsans-product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.sewsans-product');
    sections.forEach((section) => {
      const variantsScript = section.querySelector('[data-product-json]');
      if (!variantsScript) return;
      const variants = JSON.parse(variantsScript.textContent);
      const draftControls = section.querySelector('[data-draft-controls]');
      const draftKey = `sewsans-party-draft-v1:${section.dataset.productHandle}`;
      let savedDraft = null;
      if (draftControls) {
        try {
          savedDraft = JSON.parse(localStorage.getItem(draftKey));
          if (!savedDraft || Date.now() - savedDraft.savedAt > 7 * 86400000) { localStorage.removeItem(draftKey); savedDraft = null; }
        } catch { savedDraft = null; }
        if (savedDraft?.reference && !new URLSearchParams(window.location.search).has('lookbook_reference')) {
          const url = new URL(window.location.href);
          url.searchParams.set('lookbook_reference', savedDraft.reference);
          if (savedDraft.image) url.searchParams.set('lookbook_image', savedDraft.image);
          try { window.history.replaceState(window.history.state, '', url.href); } catch {}
        }
      }
      const referencePanel = section.querySelector('[data-lookbook-reference]');
      const getInspirationImage = () => {
        try {
          const raw = new URLSearchParams(window.location.search).get('lookbook_image');
          if (!raw) return '';
          const url = new URL(raw, window.location.href);
          if (url.protocol !== 'https:') return '';
          if (url.hostname !== 'cdn.shopify.com' && !(url.origin === window.location.origin && url.pathname.startsWith('/cdn/shop/'))) return '';
          url.searchParams.set('width', '400');
          return url.href;
        } catch { return ''; }
      };
      const referenceValue = new URLSearchParams(window.location.search).get('lookbook_reference');
      if (referencePanel && referenceValue && referenceValue.trim()) {
        const reference = referenceValue.trim().slice(0, 1000);
        referencePanel.querySelector('[data-lookbook-reference-text]').textContent = reference;
        const referenceImage = referencePanel.querySelector('[data-lookbook-reference-image]');
        const referenceImageUrl = getInspirationImage();
        if (referenceImage && referenceImageUrl) {
          referenceImage.alt = reference;
          referenceImage.addEventListener('error', () => { referenceImage.hidden = true; }, { once: true });
          referenceImage.src = referenceImageUrl;
          referenceImage.hidden = false;
        }
        const referenceInput = referencePanel.querySelector('[data-lookbook-reference-input]');
        referenceInput.value = reference;
        referenceInput.disabled = false;
        referencePanel.hidden = false;
        const inspirationNote = `Lookbook inspiration: ${reference}`;
        const fabricFields = Array.from(section.querySelectorAll('textarea[data-own-fabric-input], textarea[data-shop-fabric-input], textarea[data-custom-print-input]'));
        const originalNotes = new Map();
        const seededNotes = new Map();
        fabricFields.forEach((field) => {
          originalNotes.set(field, field.value);
          if (!field.value.includes(inspirationNote)) {
            field.value = field.value.trim()
              ? `${field.value}\n\n${inspirationNote}`
              : inspirationNote;
          }
          seededNotes.set(field, field.value);
        });
        referencePanel.querySelector('[data-remove-inspiration]')?.addEventListener('click', () => {
          fabricFields.forEach((field) => {
            if (field.value === seededNotes.get(field)) {
              const original = originalNotes.get(field);
              field.value = original.includes(inspirationNote)
                ? original.split('\n').filter(line => line.replace(/\r$/, '') !== inspirationNote).join('\n')
                : original;
            } else if (field.value.endsWith(`\n\n${inspirationNote}`)) {
              field.value = field.value.slice(0, -(`\n\n${inspirationNote}`.length));
            } else {
              field.value = field.value.split('\n').filter(line => line.replace(/\r$/, '') !== inspirationNote).join('\n');
            }
          });
          referenceInput.value = '';
          referenceInput.disabled = true;
          referencePanel.querySelector('[data-lookbook-reference-text]').textContent = '';
          if (referenceImage) {
            referenceImage.hidden = true;
            referenceImage.removeAttribute('src');
            referenceImage.alt = '';
          }
          referencePanel.hidden = true;
          const status = section.querySelector('[data-inspiration-status]');
          if (status) status.textContent = status.dataset.removedMessage;
          try {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete('lookbook_reference');
            currentUrl.searchParams.delete('lookbook_image');
            window.history.replaceState(window.history.state, '', currentUrl.href);
          } catch {}
          referenceInput.dispatchEvent(new Event('input', { bubbles: true }));
          section.querySelector('[data-option-select]:not(:disabled)')?.focus({ preventScroll: true });
        });
      }

      const optionSelects = Array.from(section.querySelectorAll('[data-option-select]'));
      const variantInput = section.querySelector('[data-variant-id]');
      const addButton = section.querySelector('[data-add-button]');
      const addButtonText = section.querySelector('[data-add-button-text]');
      const priceContainer = section.querySelector('[data-product-price]');
      const stickyCart = section.querySelector('[data-sticky-cart]');
      const stickyCartButton = section.querySelector('[data-sticky-cart-button]');
      const stickyCartPrice = section.querySelector('[data-sticky-cart-price]');
      const mainMedia = section.querySelector('[data-main-media]');
      const zoomOpen = section.querySelector('[data-zoom-open]');
      const zoomDialog = section.querySelector('[data-zoom-dialog]');
      if (zoomOpen && zoomDialog && typeof zoomDialog.showModal === 'function') {
        const zoomImage = zoomDialog.querySelector('[data-zoom-image]');
        const zoomStage = zoomDialog.querySelector('[data-zoom-stage]');
        const zoomToggle = zoomDialog.querySelector('[data-zoom-toggle]');
        const zoomError = zoomDialog.querySelector('[data-zoom-error]');
        const resetZoom = () => {
          zoomStage.classList.remove('is-zoomed');
          zoomStage.scrollTop = 0;
          zoomStage.scrollLeft = 0;
          zoomToggle.setAttribute('aria-pressed', 'false');
          zoomToggle.textContent = zoomToggle.dataset.zoomInLabel;
        };
        zoomOpen.hidden = false;
        zoomOpen.addEventListener('click', () => {
          const selectedImage = mainMedia.querySelector('img');
          if (!selectedImage || mainMedia.getAttribute('aria-busy') === 'true') return;
          resetZoom();
          zoomError.hidden = true;
          zoomToggle.disabled = true;
          zoomImage.alt = selectedImage.alt;
          const source = new URL(selectedImage.src, window.location.href);
          source.searchParams.set('width', '2400');
          zoomImage.src = source.href;
          zoomDialog.showModal();
        });
        zoomImage.addEventListener('load', () => {
          zoomError.hidden = true;
          zoomToggle.disabled = false;
        });
        zoomImage.addEventListener('error', () => {
          zoomError.hidden = false;
          zoomToggle.disabled = true;
        });
        zoomToggle.addEventListener('click', () => {
          const expanded = zoomStage.classList.toggle('is-zoomed');
          zoomToggle.setAttribute('aria-pressed', String(expanded));
          zoomToggle.textContent = expanded ? zoomToggle.dataset.zoomOutLabel : zoomToggle.dataset.zoomInLabel;
          zoomStage.scrollTop = 0;
          zoomStage.scrollLeft = 0;
        });
        zoomDialog.querySelector('[data-zoom-close]').addEventListener('click', () => zoomDialog.close());
        zoomDialog.addEventListener('click', (event) => {
          if (event.target !== zoomDialog) return;
          const bounds = zoomDialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) zoomDialog.close();
        });
        zoomDialog.addEventListener('close', () => {
          resetZoom();
          zoomOpen.focus({ preventScroll: true });
        });
      }

      let mediaLoadRequest = 0;
      const loadMainImage = (imageUrl, imageSrcset = '', imageAlt = '') => {
        if (!mainMedia || !imageUrl) return Promise.resolve(false);
        const image = mainMedia.querySelector('img');
        if (!image) return Promise.resolve(false);
        const requestId = ++mediaLoadRequest;
        mainMedia.classList.add('is-loading');
        mainMedia.setAttribute('aria-busy', 'true');
        return new Promise((resolve) => {
          const preloader = new Image();
          if (imageSrcset) {
            preloader.srcset = imageSrcset;
            preloader.sizes = image.sizes || '(min-width: 990px) 56vw, 100vw';
          }
          preloader.onload = () => {
            if (requestId !== mediaLoadRequest) { resolve(false); return; }
            image.src = imageUrl;
            image.srcset = imageSrcset;
            if (imageSrcset) image.sizes = '(min-width: 990px) 56vw, 100vw';
            if (imageAlt) image.alt = imageAlt;
            mainMedia.classList.remove('is-loading');
            mainMedia.setAttribute('aria-busy', 'false');
            syncGallery(imageUrl);
            resolve(true);
          };
          preloader.onerror = () => {
            if (requestId === mediaLoadRequest) {
              mainMedia.classList.remove('is-loading');
              mainMedia.setAttribute('aria-busy', 'false');
            }
            resolve(false);
          };
          preloader.src = imageUrl;
        });
      };
      const moneyConfigScript = section.querySelector('[data-money-config]');
      const moneyConfig = moneyConfigScript ? JSON.parse(moneyConfigScript.textContent) : { money_format: '$' + '{' + '{amount}}', currency: 'USD' };
      const normalize = (value) => String(value || '').trim().toLowerCase();
      const findOptionSelect = (optionName) => optionSelects.find((select) => normalize(select.dataset.optionName) === normalize(optionName));
      const shirtOptionSelect = findOptionSelect('Shirt Option');
      const shirtPhotoHost = section.querySelector('[data-shirt-photo-host]');
      const shirtPhotoTemplates = Array.from(section.querySelectorAll('[data-shirt-photo-template]'));
      let activeShirtPhoto = null;
      const updateShirtTypePhoto = () => {
        if (!shirtPhotoHost || !shirtOptionSelect) return;
        const template = shirtPhotoTemplates.find(item => normalize(item.dataset.shirtValue) === normalize(shirtOptionSelect.value));
        if (template === activeShirtPhoto) return;
        activeShirtPhoto = template;
        shirtPhotoHost.replaceChildren();
        shirtPhotoHost.hidden = true;
        if (!template) return;
        const content = template.content.cloneNode(true);
        const caption = content.querySelector('[data-shirt-photo-caption]');
        if (caption) caption.textContent = shirtOptionSelect.selectedOptions[0]?.textContent.trim() || shirtOptionSelect.value;
        const image = content.querySelector('img');
        if (!image) return;
        image.addEventListener('error', () => {
          if (shirtPhotoHost.contains(image)) shirtPhotoHost.hidden = true;
        }, { once: true });
        shirtPhotoHost.append(content);
        shirtPhotoHost.hidden = false;
      };
      const fabricChoiceSelect = findOptionSelect('Fabric Choice') || findOptionSelect('Customization Level') || findOptionSelect('Customization') || optionSelects.find((select) => {
        const values = Array.from(select.options).map((option) => normalize(option.value)).join(' ');
        return values.includes('own fabric') || values.includes('existing fabric') || values.includes('shop fabric') || values.includes('custom print') || values.includes('custom design');
      });
      const sizingMethod = section.querySelector('[data-party-sizing-method]');
      const shirtSizingGroup = section.querySelector('[data-shirt-sizing]');
      const ownShirtNote = section.querySelector('[data-own-shirt-note]');
      const mensSizingPanel = section.querySelector('[data-mens-sizing]');
      const womensSizingPanel = section.querySelector('[data-womens-sizing]');
      const mensSizingInputs = Array.from(section.querySelectorAll('[data-mens-sizing-input]'));
      const womensSizingInputs = Array.from(section.querySelectorAll('[data-womens-sizing-input]'));
      const ownFabricPanel = section.querySelector('[data-fabric-own]');
      const shopFabricPanel = section.querySelector('[data-fabric-shop]');
      const customPrintPanel = section.querySelector('[data-fabric-custom]');
      const materialShippingNote = section.querySelector('[data-material-shipping-note]');
      const setPanelState = (panel, shouldShow) => {
        if (!panel) return;
        panel.hidden = !shouldShow;
        panel.querySelectorAll('input, select, textarea').forEach((control) => { control.disabled = !shouldShow; });
      };
      const formatMoney = (cents) => {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, moneyConfig.money_format);
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: moneyConfig.currency || 'USD' }).format(cents / 100);
      };
      const syncStickyCart = () => {
        if (!stickyCartButton) return;
        stickyCartButton.disabled = !addButton || addButton.disabled;
        stickyCartButton.textContent = addButtonText ? addButtonText.textContent.trim() : 'Add to Cart';
        if (stickyCartPrice && priceContainer) stickyCartPrice.textContent = priceContainer.textContent.trim();
      };
      const updateStickyCartVisibility = () => {
        if (!stickyCart || !addButton) return;
        const bounds = addButton.getBoundingClientRect();
        const mainButtonVisible = bounds.top < window.innerHeight && bounds.bottom > 0;
        const shouldShow = window.scrollY > 240 && !mainButtonVisible;
        stickyCart.hidden = !shouldShow;
        section.classList.toggle('sewsans-product--sticky-visible', shouldShow);
      };
      const selectedOptions = () => optionSelects.map((select) => select.value);
      const findVariant = () => {
        const selections = selectedOptions();
        return variants.find((variant) => variant.options.every((value, index) => value === selections[index]));
      };
      const updateSizingFields = () => {
        if (!sizingMethod) return;
        const shirtValue = normalize(shirtOptionSelect ? shirtOptionSelect.value : '');
        const isOwnShirt = shirtValue.includes('own shirt');
        if (shirtSizingGroup) shirtSizingGroup.hidden = isOwnShirt;
        if (ownShirtNote) ownShirtNote.hidden = !isOwnShirt;
        sizingMethod.disabled = isOwnShirt;
        const showMens = !isOwnShirt && sizingMethod.value === "Men's Neck / Sleeve";
        const showWomens = !isOwnShirt && sizingMethod.value === "Women's Size";
        if (mensSizingPanel) mensSizingPanel.hidden = !showMens;
        if (womensSizingPanel) womensSizingPanel.hidden = !showWomens;
        mensSizingInputs.forEach((input) => { input.disabled = !showMens; });
        womensSizingInputs.forEach((input) => { input.disabled = !showWomens; });
      };
      const updateFabricFields = () => {
        const fabricValue = normalize(fabricChoiceSelect ? fabricChoiceSelect.value : '');
        const showOwn = fabricValue.includes('own fabric') || fabricValue.includes('customer fabric') || fabricValue.includes('customer-supplied fabric');
        const showShop = fabricValue.includes('shop fabric') || fabricValue.includes('existing fabric') || fabricValue.includes('sourced fabric') || fabricValue.includes('commercially available');
        const showCustom = fabricValue.includes('custom print') || fabricValue.includes('custom design') || fabricValue.includes('fully custom') || fabricValue.includes('custom fabric');
        setPanelState(ownFabricPanel, showOwn);
        setPanelState(shopFabricPanel, showShop);
        setPanelState(customPrintPanel, showCustom);
      };
      const updatePriceExplanation = () => {
        const summary = section.querySelector('[data-price-explanation]');
        if (!summary) return;
        const shirtNote = summary.querySelector('[data-shirt-price-note]');
        const fabricNote = summary.querySelector('[data-fabric-price-note]');
        const shirtValue = shirtOptionSelect ? shirtOptionSelect.value : '';
        const normalizedShirtValue = normalize(shirtValue);
        const isOwnShirt = normalizedShirtValue.includes('own shirt');
        const fabricValue = normalize(fabricChoiceSelect ? fabricChoiceSelect.value : '');
        const isOwnFabric = fabricValue.includes('own fabric') || fabricValue.includes('customer fabric') || fabricValue.includes('customer-supplied fabric');
        if (shirtNote) shirtNote.textContent = normalize(shirtValue).includes('own shirt')
          ? 'This selection covers sewing using the shirt you provide.'
          : shirtValue ? `This selection includes the ${shirtValue} shirt and sewing.` : '';
        if (fabricNote) {
          if (fabricValue.includes('own fabric') || fabricValue.includes('customer fabric') || fabricValue.includes('customer-supplied fabric')) {
            fabricNote.textContent = ' You provide the fabric.';
          } else if (fabricValue.includes('shop fabric') || fabricValue.includes('existing fabric') || fabricValue.includes('sourced fabric') || fabricValue.includes('commercially available')) {
            fabricNote.textContent = ' Sewsan’s sources commercially available fabric based on your request.';
          } else if (fabricValue.includes('custom print') || fabricValue.includes('custom design') || fabricValue.includes('fully custom') || fabricValue.includes('custom fabric')) {
            fabricNote.textContent = ' Includes custom printed fabric, up to two hours of design work, and one revision.';
          } else { fabricNote.textContent = ''; }
        }
        if (materialShippingNote) {
          const customerSuppliesMaterials = isOwnShirt || isOwnFabric;
          materialShippingNote.hidden = !customerSuppliesMaterials;
          materialShippingNote.textContent = customerSuppliesMaterials
            ? 'After ordering, we’ll send shipping instructions. You’re responsible for shipping the materials you supply to Sewsan’s.'
            : '';
        }
        summary.hidden = !findVariant();
      };
      const updatePartyShirtFields = () => { updateSizingFields(); updateFabricFields(); updatePriceExplanation(); updateShirtTypePhoto(); };
      const updateVariant = () => {
        const variant = findVariant();
        if (!variant) {
          if (variantInput) variantInput.value = '';
          if (priceContainer) priceContainer.textContent = 'Unavailable combination';
          if (addButton) addButton.disabled = true;
          if (addButtonText) addButtonText.textContent = 'Unavailable';
          syncStickyCart();
          return;
        }
        if (variantInput) variantInput.value = variant.id;
        if (addButton) addButton.disabled = !variant.available;
        if (addButtonText) addButtonText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
        if (priceContainer) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceContainer.innerHTML = `<span class="sewsans-product__price-sale">${formatMoney(variant.price)}</span><span class="sewsans-product__price-compare">${formatMoney(variant.compare_at_price)}</span>`;
          } else { priceContainer.innerHTML = `<span>${formatMoney(variant.price)}</span>`; }
        }
        if (variant.featured_image && mainMedia) loadMainImage(variant.featured_image.src, '', variant.featured_image.alt || '');
        syncStickyCart();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      if (sizingMethod) sizingMethod.addEventListener('change', updateSizingFields);
      if (stickyCartButton) stickyCartButton.addEventListener('click', () => { if (addButton && !addButton.disabled) { const form = addButton.form; if (form && form.reportValidity()) form.requestSubmit(addButton); } });
      if (stickyCart) {
        window.addEventListener('scroll', updateStickyCartVisibility, { passive: true });
        window.addEventListener('resize', updateStickyCartVisibility);
        syncStickyCart();
        updateStickyCartVisibility();
      }
      optionSelects.forEach((select) => { select.addEventListener('change', () => { updateVariant(); updatePartyShirtFields(); }); });
      updatePartyShirtFields();
      const summaryList = section.querySelector('[data-order-summary]');
      const summaryTotal = section.querySelector('[data-order-total]');
      const selectionStatus = section.querySelector('[data-selection-status]');
      const quantityInput = section.querySelector('[name="quantity"]');
      const updateOrderSummary = () => {
        if (!summaryList) return;
        const variant = findVariant();
        summaryList.replaceChildren();
        const addRow = (label, value) => {
          if (!value) return;
          const row = document.createElement('div');
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = label;
          description.textContent = value;
          row.append(term, description);
          summaryList.append(row);
        };
        const inspirationInput = section.querySelector('[data-lookbook-reference-input]');
        if (inspirationInput && !inspirationInput.disabled && inspirationInput.value.trim()) {
          addRow('Lookbook inspiration', inspirationInput.value.trim());
          const inspirationImage = getInspirationImage();
          if (inspirationImage) {
            const thumbnail = document.createElement('img');
            thumbnail.className = 'sewsans-product__inspiration-thumbnail';
            thumbnail.alt = inspirationInput.value.trim();
            thumbnail.width = 120;
            thumbnail.height = 150;
            thumbnail.loading = 'lazy';
            thumbnail.addEventListener('error', () => thumbnail.remove(), { once: true });
            thumbnail.src = inspirationImage;
            summaryList.lastElementChild.querySelector('dd').append(thumbnail);
          }
        }
        optionSelects.forEach(select => {
          addRow(select.dataset.optionName, select.selectedOptions[0]?.textContent.trim());
          const hint = select.closest('.sewsans-product__option')?.querySelector('[data-option-help]');
          if (hint) {
            const value = normalize(select.value);
            hint.textContent = select === shirtOptionSelect
              ? (value.includes('own shirt') ? 'You supply the shirt; the price covers the selected sewing and fabric services.' : 'Sewsan’s supplies the selected shirt for your order.')
              : select === fabricChoiceSelect
                ? (value.includes('own fabric') ? 'You supply the fabric. Shipping instructions arrive after ordering.' : value.includes('custom print') || value.includes('custom design') ? 'Fabric is printed for your design. Add your concept and references below.' : 'Describe the commercially available fabric you want Sewsan’s to source below.')
                : '';
          }
        });
        if (sizingMethod && !sizingMethod.disabled) {
          addRow('Sizing method', sizingMethod.value);
          [...mensSizingInputs, ...womensSizingInputs].filter(input => !input.disabled).forEach(input => {
            const label = input.labels?.[0]?.textContent || 'Size';
            addRow(label, input.value || 'Not entered yet');
          });
        }
        section.querySelectorAll('.sewsans-product__form input[type="file"]').forEach(field => {
          if (field.disabled || !field.files || !field.files.length) return;
          const label = field.labels?.[0]?.textContent.trim() || 'Attached files';
          addRow(label, Array.from(field.files).map(file => file.name).join(', '));
          const description = summaryList.lastElementChild.querySelector('dd');
          const changeFiles = document.createElement('button');
          changeFiles.type = 'button';
          changeFiles.className = 'sewsans-product__change-files';
          changeFiles.textContent = section.dataset.changeFilesLabel || 'Change files';
          changeFiles.setAttribute('aria-label', `${changeFiles.textContent}: ${label}`);
          changeFiles.addEventListener('click', () => {
            if (field.disabled) return;
            let parent = field.parentElement;
            while (parent && parent !== section) {
              if (parent.tagName === 'DETAILS') parent.open = true;
              parent = parent.parentElement;
            }
            field.scrollIntoView({ block: 'center', behavior: 'instant' });
            field.focus({ preventScroll: true });
          });
          description.append(document.createElement('br'), changeFiles);
        });
        const eventDate = section.querySelector('[name="properties[Event / Need-By Date]"]');
        if (eventDate?.value) addRow('Requested need-by date (subject to confirmation)', eventDate.value);
        const quantity = Math.max(1, Math.floor(Number(quantityInput?.value) || 1));
        if (summaryTotal) summaryTotal.textContent = variant ? formatMoney(variant.price * quantity) : 'Unavailable';
        if (selectionStatus) selectionStatus.textContent = !variant ? 'This combination is unavailable. Choose another shirt or fabric option.' : !variant.available ? 'This combination is currently sold out.' : '';
      };
      if (summaryList) {
        const form = section.querySelector('.sewsans-product__form');
        form.addEventListener('input', updateOrderSummary);
        form.addEventListener('change', updateOrderSummary);
        updateOrderSummary();
      }
      if (draftControls) {
        const draftForm = section.querySelector('.sewsans-product__form');
        const draftStatus = draftControls.querySelector('[data-draft-status]');
        const editableFields = () => Array.from(draftForm.querySelectorAll('input, select, textarea')).filter(field => field.id && !['hidden', 'file', 'submit', 'button'].includes(field.type));
        const snapshot = () => Object.fromEntries(editableFields().map(field => [field.id, { value: field.value, checked: field.checked }]));
        const initialFields = snapshot();
        const explicitVariant = new URLSearchParams(window.location.search).has('variant');
        const explicitReference = new URLSearchParams(window.location.search).get('lookbook_reference');
        if (savedDraft?.fields && (!explicitReference || explicitReference === savedDraft.reference)) {
          editableFields().forEach(field => {
            const saved = savedDraft.fields[field.id];
            if (!saved || (explicitVariant && field.matches('[data-option-select]'))) return;
            if (field.tagName === 'SELECT' && !Array.from(field.options).some(option => option.value === saved.value)) return;
            field.value = saved.value;
            if (['checkbox', 'radio'].includes(field.type)) field.checked = !!saved.checked;
          });
          updateVariant();
          updatePartyShirtFields();
          updateOrderSummary();
          draftStatus.textContent = 'Your saved selections were restored. Please reattach any files.';
        }
        let submittingDraft = false;
        const saveDraft = () => {
          if (submittingDraft) return;
          const referenceInput = section.querySelector('[data-lookbook-reference-input]');
          try {
            localStorage.setItem(draftKey, JSON.stringify({ savedAt: Date.now(), fields: snapshot(), reference: referenceInput && !referenceInput.disabled ? referenceInput.value : '', image: referenceInput && !referenceInput.disabled ? getInspirationImage() : '' }));
            draftStatus.textContent = 'Selections saved on this device for 7 days. Uploaded files are not saved.';
          } catch { draftStatus.textContent = 'Your browser could not save these selections. You can still place your order.'; }
        };
        draftForm.addEventListener('input', saveDraft);
        draftForm.addEventListener('change', saveDraft);
        draftControls.querySelector('[data-clear-draft]').addEventListener('click', () => {
          section.querySelector('[data-remove-inspiration]')?.click();
          editableFields().forEach(field => {
            const initial = initialFields[field.id];
            if (!initial) return;
            field.value = initial.value;
            if (['checkbox', 'radio'].includes(field.type)) field.checked = initial.checked;
            if (field.tagName === 'TEXTAREA') field.value = '';
          });
          draftForm.querySelectorAll('input[type="file"]').forEach(field => { field.value = ''; });
          try { localStorage.removeItem(draftKey); } catch {}
          updateVariant(); updatePartyShirtFields(); updateOrderSummary();
          draftStatus.textContent = 'Saved selections cleared. Start a new configuration below.';
        });
        draftForm.addEventListener('submit', async event => {
          if (event.defaultPrevented) return;
          event.preventDefault();
          if (submittingDraft || !draftForm.reportValidity()) return;
          saveDraft();
          const payload = new FormData(draftForm);
          submittingDraft = true;
          addButton.disabled = true;
          draftStatus.textContent = 'Adding your shirt to the cart…';
          try {
            const endpoint = new URL(draftForm.action, window.location.href);
            endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
            const response = await fetch(endpoint.href, { method: 'POST', body: payload, headers: { Accept: 'application/json' } });
            const result = await response.json();
            if (!response.ok || result.status >= 400) throw new Error(result.description || result.message || 'Your shirt could not be added. Please try again.');
            try { localStorage.removeItem(draftKey); } catch {}
            window.location.assign(draftControls.dataset.cartUrl);
          } catch (error) {
            draftStatus.textContent = error.message || 'Your shirt could not be added. Your selections are saved.';
            submittingDraft = false;
            updateVariant();
          }
        });
      }
      const galleryThumbs = Array.from(section.querySelectorAll('[data-thumb]'));
      const galleryCounter = section.querySelector('[data-image-counter]');
      let galleryIndex = Math.max(0, galleryThumbs.findIndex(thumb => thumb.classList.contains('is-active')));
      function syncGallery(imageUrl) {
        const path = value => { try { return new URL(value, window.location.href).pathname; } catch { return value; } };
        const index = galleryThumbs.findIndex(thumb => path(thumb.dataset.imageUrl) === path(imageUrl));
        if (index >= 0) galleryIndex = index;
        galleryThumbs.forEach((thumb, position) => {
          thumb.classList.toggle('is-active', position === galleryIndex);
          thumb.setAttribute('aria-current', position === galleryIndex ? 'true' : 'false');
        });
        if (galleryCounter && galleryThumbs.length > 1) {
          galleryCounter.textContent = `${galleryIndex + 1} / ${galleryThumbs.length}`;
          galleryCounter.hidden = false;
        }
      }
      const selectGalleryImage = async index => {
        const thumb = galleryThumbs[index];
        if (!thumb) return;
        thumb.setAttribute('aria-busy', 'true');
        await loadMainImage(thumb.dataset.imageUrl, thumb.dataset.imageSrcset || '', thumb.dataset.imageAlt || '');
        thumb.removeAttribute('aria-busy');
      };
      galleryThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectGalleryImage(index)));
      if (galleryThumbs.length) syncGallery(mainMedia?.querySelector('img')?.src || galleryThumbs[galleryIndex].dataset.imageUrl);
      if (mainMedia && galleryThumbs.length > 1) {
        let startTouch = null;
        let suppressClickUntil = 0;
        mainMedia.addEventListener('touchstart', event => {
          startTouch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { passive: true });
        mainMedia.addEventListener('touchcancel', () => { startTouch = null; }, { passive: true });
        mainMedia.addEventListener('touchend', event => {
          if (!startTouch || event.touches.length || event.changedTouches.length !== 1) { startTouch = null; return; }
          const dx = event.changedTouches[0].clientX - startTouch.x;
          const dy = event.changedTouches[0].clientY - startTouch.y;
          startTouch = null;
          if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
          suppressClickUntil = Date.now() + 500;
          const direction = getComputedStyle(mainMedia).direction === 'rtl' ? -1 : 1;
          const nextIndex = (galleryIndex + (dx < 0 ? direction : -direction) + galleryThumbs.length) % galleryThumbs.length;
          selectGalleryImage(nextIndex);
        }, { passive: true });
        mainMedia.addEventListener('click', event => {
          if (Date.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, true);
      }
      section.querySelectorAll('.sewsans-product__size-link').forEach((link) => {
        link.addEventListener('click', () => {
          const guide = section.querySelector('.sewsans-product__size-guide');
          if (guide) guide.open = true;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
